import axios from 'axios'

const api = axios.create({
   //baseURL: 'http://localhost:5000/api',
   baseURL: 'https://pdf2doc.toolhero.top/api',
  timeout: 180000
})

// Add request interceptor to include auth token
const token = localStorage.getItem('token')
if (token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export default api